import { render, staticRenderFns } from "./NeedMoreHelpIcon.vue?vue&type=template&id=0a67bb6c&scoped=true"
import script from "./NeedMoreHelpIcon.vue?vue&type=script&lang=ts"
export * from "./NeedMoreHelpIcon.vue?vue&type=script&lang=ts"
import style0 from "./NeedMoreHelpIcon.vue?vue&type=style&index=0&id=0a67bb6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a67bb6c",
  null
  
)

export default component.exports